import React, {
  useCallback,
  useState,
} from "react"
import types from "prop-types"
import AddWhitelistedUserEmailDesc from "./AddWhitelistedUserEmailDesc"
import WhitelistedDescription from "./WhitelistedDescription"

const WhitelistedUserEmailDescriptions = ({ organization, whitelistedUserEmailDescriptions: originalWhitelistedUserEmailDescriptions }) => {
  const [whitelistedUserEmailDescriptions, setWhitelistedUserEmailDescriptions] = useState(originalWhitelistedUserEmailDescriptions)

  const addWhitelistedUserEmailDesc = useCallback((whitelistEntry) => {
    setWhitelistedUserEmailDescriptions([...whitelistedUserEmailDescriptions, whitelistEntry])
  }, [whitelistedUserEmailDescriptions, setWhitelistedUserEmailDescriptions])

  return (
    <>
      <ul className="list-none pl-0 mb-8">
        {
          whitelistedUserEmailDescriptions.map((description) => (
            <li key={description.id}>
              <WhitelistedDescription description={description} />
            </li>
          ))
        }
      </ul>
      <AddWhitelistedUserEmailDesc
        addWhitelistedUserEmailDesc={addWhitelistedUserEmailDesc}
        organization={organization}
      />
    </>
  )
}

WhitelistedUserEmailDescriptions.propTypes = {
  organization: types.object.isRequired,
  whitelistedUserEmailDescriptions: types.arrayOf(types.object).isRequired,
}

export default WhitelistedUserEmailDescriptions
